module.exports = __webpack_public_path__ + "static/media/bartini.c7b2dbe0.png";